<div class="container-fluid" style="padding: 0; ">
 
    <div class="ng-Header col-xs-12">
      <i nz-icon nzType="form" nzTheme="outline"></i> Update Basic Profile
    </div>
    <div class="searchboxAerar" style="background-color: #FFF;">
      <form nz-form [formGroup]="basicProfileForm">

        <div class="form-row" style="margin-left: 12px">

          <div class="col-md-4">
            <nz-form-label nzRequired>Name of STP</nz-form-label>
            <div class="col-md-12">
              <nz-form-item>
                <nz-form-control nzHasFeedback [nzErrorTip]="stpNameErrorTpl" disabled>
                  <input nz-input formControlName="stpName" (keyup)=" checkStpNameExist($event.target)" />
                  <ng-template #stpNameErrorTpl let-control>
                    <ng-container *ngIf="control.hasError('required')">
                      Please input STP name!
                    </ng-container>
                    <!-- <ng-container *ngIf="control.hasError('pattern')">
                      Please input valid STP name!
                    </ng-container> -->
                  </ng-template>
                </nz-form-control>
                <div *ngIf="stpNameAlredyExist" class="text-danger">
                  <p>This STP name is already registered. Please use different
                    STP name</p>
                </div>
              </nz-form-item>

            </div>
          </div>

          <div class="col-md-4">
            <nz-form-label nzRequired> Name of STP in Bangla</nz-form-label>
            <div class="col-md-12">
              <nz-form-item>
                <nz-form-control [nzSpan]="20" nzHasFeedback nzValidatingTip="Validating...">
                  <input nz-input formControlName="stpNameBangla" placeholder="STP Name Bangla" />
                </nz-form-control>
              </nz-form-item>

            </div>
          </div>
        </div>
        <div class="row justify-content-center media-button">

          <div class="col-xs-6 col-sm-2">
            <button type="button" class="btn btn-success active btn-lg btn-block cari border-redius"
              [disabled]="!basicProfileForm.valid" (click)="update()"><i nz-icon nzType="save" nzTheme="fill"></i>
              Update</button>


          </div>
        </div>
      </form>
    </div>
 
</div>
